<template>
  <div class="relative pb-8">
    <div
      class="overflow-hidden transition-all"
      :class="{ 'is-shortened': active, mask: !open && active, 'mask-read-more': !open && active }"
      :style="{ maxHeight: !open && active ? maxHeightLimit + 'px' : '2000px' }"
      ref="content"
    >
      <article class="prose">
        <slot></slot>
      </article>
    </div>

    <button
      v-if="active"
      @click.prevent="open = !open"
      class="absolute -bottom-2 left-0 z-20 flex w-full"
      :class="{ 'bg-gradient-to-b pt-32': !open }"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.5 12L7.50068 11.9993" stroke="#1B83A2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path v-if="!open" d="M12 7.5L12.0007 16.4993" stroke="#1B83A2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
          stroke="#1B83A2"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span class="px-2">Read {{ open ? "Less" : "More" }}</span>
    </button>
  </div>
</template>
<script>
export default {
  props: {
    maxHeightLimit: {
      type: Number,
      default: 360,
    },
    colour: {
      type: String,
      default: "blue",
    },
  },
  data() {
    return {
      open: false,
      active: false,
    }
  },
  mounted() {
    this.active = this.$refs.content.offsetHeight > this.maxHeightLimit
  },
}
</script>
<style scoped>
.mask {
  mask-image: linear-gradient(to bottom, black 50%, transparent 100%);
  -webkit-mask-image: linear-gradient(to bottom, black 50%, transparent 100%);
}

.is-shortened {
  max-height: 360px;
}

.is-active {
  max-height: 2000px;
}
</style>
